var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"wrap":"","dense":""}},_vm._l((_vm.orders),function(o){return _c('v-col',{key:o._id,attrs:{"cols":"12","sm":"6","md":"4","lg":"3"}},[_c('Cell',{attrs:{"order":o}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }